import { useState, useContext } from 'react';
import UserContext from "../../contexts/userContext";

import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export const ChatPromptTemplate = ({chatTemplates}) => {
    const { userContext, setUserContext } = useContext(UserContext);

    const [ selectedTemplate, setSelectedTemplate ] = useState(chatTemplates.filter(x => x.isActive)[0]);
    const [ templateDefinition, setTemplateDefinition ] = useState(selectedTemplate.definition);
    const [ isTemplateDirty, setIsTemplateDirty ] = useState({
        session: false,
        repo: false
    });

    const chatTemplateType = selectedTemplate.usesContext ? 'withContext' : 'withoutContext';
    
    const selectTemplate = (changeEvent) => {
        const i = parseInt(changeEvent.target.value);
        if (i !== selectedTemplate.i) {
            setSelectedTemplate(chatTemplates[i]);
            setTemplateDefinition(chatTemplates[i].definition);
            setIsTemplateDirty({
                session: false,
                repo: false
            });
        }
    };

    const updateEphemeralDefinition = (changeEvent) => {
        const ephemeralDefinition = changeEvent.target.value;
        if (ephemeralDefinition !== selectedTemplate.definition) {
            setTemplateDefinition(ephemeralDefinition);
            setIsTemplateDirty({
                session: true,
                repo: true
            });
        }
    };

    const activateTemplate = () => {
        const tempUserContext = {...userContext};
        tempUserContext.templates.chat[chatTemplateType] = tempUserContext.templates.chat[chatTemplateType].map(template => {
            template.isActive = false;
            return template;
        });

        const i = selectedTemplate.i;
        tempUserContext.templates.chat[chatTemplateType][i].definition = templateDefinition;
        tempUserContext.templates.chat[chatTemplateType][i].isActive = true;
        setUserContext(tempUserContext);
    };

    const updateTemplateInRepo = (updateType) => {
        const apiGatewayInvokeUrl = process.env[`REACT_APP_API_GATEWAY_INVOKE_URL__${process.env["REACT_APP_DEPLOYMENT_TYPE"]}`];
        const endpoint = `${apiGatewayInvokeUrl}/templates/chat`;
        const body = {
            usesContext: selectedTemplate.usesContext,
            definition: templateDefinition
        };

        if (updateType==='update' || updateType==='delete') {
            body.id = selectedTemplate.id;
        }

        const params = {
            method: updateType === 'delete' ? 'DELETE' : 'POST',
            headers: {
                "Authorization": `Bearer ${userContext.account.idToken}`
            },
            body: JSON.stringify(body)
        };

        fetch(endpoint, params)
            .then(() => setIsTemplateDirty({
                session: setIsTemplateDirty.session,
                repo: false
            }));
    };

    return <>
        <Form.Select 
            id="promptTemplateSelect"
            className="mb-4"
            value={selectedTemplate.i}
            onChange={changeEvent => selectTemplate(changeEvent)}
        >
            {chatTemplates.map((chatTemplate, i) => {
                const label = `${chatTemplate.id}${chatTemplate.isActive ? ' (active)' : ''}`;
                return (
                    <option key={i} value={i}>{label}</option>
                );
            })}
        </Form.Select>

        <Form.Control
            id="promptTemplateTextArea"
            as="textarea"
            rows={20}
            placeholder="Enter prompt template here"
            value={templateDefinition}
            onChange={(changeEvent) => updateEphemeralDefinition(changeEvent)}
        />
        
        <Modal.Footer style={{"borderTop":"none", "paddingRight":0}}>
            <Button
                variant="info"
                onClick={activateTemplate}
            >
                Activate for This Session
            </Button>

            <Button
                variant="primary"
                disabled={!isTemplateDirty.repo || selectedTemplate.doPreserve}
                onClick={() => updateTemplateInRepo('update')}
            >
                Update in Repo
            </Button>

            <Button
                variant="success"
                disabled={!isTemplateDirty.repo}
                onClick={() => updateTemplateInRepo('add')}
            >
                Create New in Repo
            </Button>

            <Button
                variant="danger"
                disabled={selectedTemplate.doPreserve}
                onClick={() => updateTemplateInRepo('delete')}
            >
                Delete from Repo
            </Button>
        </Modal.Footer>
    </>
}